module.exports = __webpack_public_path__ + "images/emoji/apple.bf3c6fb5d47d4275d2b7.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/apple.png
// module id = MTp9
// module chunks = 24